import { languages } from "./languages";

export default {
  present: {
    name: languages.teams.present,
  },
  payed: {
    name: languages.teams.payed,
  },
  // name: {
  //   name: "Naam",
  // },
  // extraField: {
  //   name: "Contactpersoon",
  // },
  email: {
    name: languages.teams.email,
  },
  added: {
    name: languages.teams.added,
  },
  country: {
    name: languages.teams.country,
  },
  logo: {
    name: languages.teams.logo,
  },
  dressingRoom: {
    name: languages.teams.dressingRoom,
  },
  players: {
    name: languages.teams.players,
  },
  shareURL: {
    name: languages.teamInfo.shareURL,
    tooltip: languages.teamInfo.shareURLDescription,
  },
  language: {
    name: languages.teamInfo.signupLanguage,
  },
};
